import React, { useState, useEffect } from "react";
import "./ManageUsuariosView.css";

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 20;

export default function ManageUsuariosView() {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const token = localStorage.getItem("access_token");

  const fetchUsuarios = async (pageNum = 0) => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(
        `${API_URL}/usuarios?skip=${pageNum * PAGE_SIZE}&limit=${PAGE_SIZE}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );
      if (res.ok) {
        const data = await res.json();
        setUsuarios(data);
        setPage(pageNum);
      } else {
        throw new Error("Error al cargar usuarios");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchTotalCount = async () => {
    try {
      const res = await fetch(`${API_URL}/usuarios?skip=0&limit=1`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // El backend no retorna total, usamos el length del response
      if (res.ok) {
        const data = await res.json();
        setTotalCount(data.length);
      }
    } catch (err) {
      console.error("Error fetching count:", err);
    }
  };

  useEffect(() => {
    fetchUsuarios();
    fetchTotalCount();
  }, []);

  const filteredUsuarios = usuarios.filter((u) =>
    u.email.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const getStatusBadge = (user) => {
    if (user.is_Admin) {
      return <span className="badge admin">Admin</span>;
    }
    if (user.is_verified) {
      return <span className="badge verified">Verificado</span>;
    }
    return <span className="badge pending">Pendiente</span>;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    try {
      return new Date(dateStr).toLocaleDateString("es", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    } catch {
      return "-";
    }
  };

  const totalPages = Math.ceil(totalCount / PAGE_SIZE) || 1;

  return (
    <div className="manage-usuarios-container">
      <div className="usuarios-header">
        <div className="header-title">
          <h2>👥 Usuarios</h2>
          <span className="count-badge">{usuarios.length}</span>
        </div>
        <div className="header-actions">
          <button
            onClick={() => fetchUsuarios(page)}
            className="refresh-btn"
            title="Actualizar"
          >
            <span className={loading ? "spinning" : ""}>🔄</span>
          </button>
        </div>
      </div>

      <div className="search-bar">
        <input
          type="text"
          placeholder="Buscar por correo..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {loading ? (
        <div className="loading-state">
          <div className="spinner"></div>
          <p>Cargando usuarios...</p>
        </div>
      ) : error ? (
        <div className="error-state">
          <p>⚠️ {error}</p>
        </div>
      ) : (
        <div className="usuarios-list-container">
          {filteredUsuarios.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">👤</div>
              <p>No hay usuarios</p>
            </div>
          ) : (
            <div className="usuarios-table">
              <div className="table-header">
                <div className="col online">Online</div>
                <div className="col email">Correo</div>
                <div className="col status">Estado</div>
                <div className="col created">Creado</div>
                <div className="col terminos">Términos</div>
              </div>
              <div className="table-body">
                {filteredUsuarios.map((user) => (
                  <div key={user.id} className="table-row">
                    <div className="col online">
                      <span
                        className={`online-indicator ${
                          user.is_online ? "online" : "offline"
                        }`}
                        title={user.is_online ? "Conectado" : "Desconectado"}
                      >
                        {user.is_online ? "🟢" : "⚪"}
                      </span>
                    </div>
                    <div className="col email">
                      <span className="email-text">{user.email}</span>
                    </div>
                    <div className="col status">{getStatusBadge(user)}</div>
                    <div className="col created">
                      <span className="date-text">
                        {formatDate(user.created_at)}
                      </span>
                    </div>
                    <div className="col terminos">
                      {user.acepta_terminos ? (
                        <span className="badge accepted">
                          ✓ v{user.version_terminos}
                        </span>
                      ) : (
                        <span className="badge not-accepted">✗</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Paginación */}
          <div className="pagination">
            <button
              onClick={() => fetchUsuarios(page - 1)}
              disabled={page === 0}
              className="page-btn"
            >
              ◀ Anterior
            </button>
            <span className="page-info">
              Página {page + 1} de {totalPages}
            </span>
            <button
              onClick={() => fetchUsuarios(page + 1)}
              disabled={page >= totalPages - 1}
              className="page-btn"
            >
              Siguiente ▶
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
